import { type TranslationTree } from '@/i18n/types';

export const messages = {
  required: 'Informe este campo',
  invalidValue: 'Informe um valor válido',
  minLength: 'Mínimo de {min} caracteres',
  maxLength: 'Máximo de {max} caracteres',
  minItems: 'Adicione ao menos {min} item(ns)',
  maxItems: 'Máximo de {max} item(ns)',
  minValue: 'Valor mínimo: {min}',
  maxValue: 'Valor máximo: {max}',
  notInteger: 'Informe um número inteiro',
  invalidUrl: 'Informe um endereço válido',
  invalidEmail: 'Informe um e-mail válido',
  invalidId: 'Informe um identificador válido',
  invalidFormat: 'Formato inválido',
  unknownField: 'Campo não aceito',
  dateInFuture: 'A data não pode ser futura',
  dateInPast: 'A data não pode ser passada',
  invalidPhone: 'Informe um telefone válido',
  invalidTaxId: 'Informe um CPF ou CNPJ válido',
  invalidPostalCode: 'Informe um CEP válido',
  alreadyExists: 'Este valor já está em uso',
  validationError: 'Verifique os dados informados',
  genericGlobal: 'Não foi possível salvar as alterações, tente novamente',
} satisfies TranslationTree;
